const REPORTS_CONSTANTS = {
  REPORT_DEVICE_HASH: 'Reports/DeviceHash',
  REPORT_BASKET_HASH_EXCEPTIONS: 'Reports/BasketHashExceptions',
  REPORT_HASH_EXCEPTIONS: 'Reports/HashExceptions',
  REPORT_CASHBACK_TENDERED: 'Reports/CashbackTendered',
  REPORT_STATEMENT_OF_ACCOUNT: 'Reports/StatementOfAccount',
};
export default REPORTS_CONSTANTS;
